<script lang="ts">
  import ButtonNew from "../buttons/ButtonNew.svelte";
  import CaretFilledIcon from "../icons/CaretFilled.svelte";

  export let isHoverActive = false;
  export let isExpanded = false;
  export let textColor: "error" | "neutral-4" = "neutral-4";
</script>

<ButtonNew
  size="xs"
  variant="icon"
  on:click
  on:mouseover
  on:mouseleave
  --icon-btn-pl="16px"
  --icon-btn-pr="24px"
  --icon-btn-height="100%"
>
  <div slot="icon" class:expansion-btn-hover={isHoverActive} style:color={textColor}>
    <CaretFilledIcon width="9px" direction={isExpanded ? "down" : "right"} />
  </div>
</ButtonNew>

<style>
  .expansion-btn-hover {
    opacity: 0.5;
  }
</style>
